/* 共有セクション（lp7系）への差し込み。レビューは loosy-lp7.js に任せるのでここでは触らない。 */
(()=>{
 const holder=document.querySelector('[data-lr-ticket-holder]');
 const pay=document.querySelector('#s8 .paycard');
 if(holder&&pay){pay.before(holder.firstElementChild);holder.remove();}
 const data=document.querySelector('[data-lr-image-overrides]');
 if(data){let images={};try{images=JSON.parse(data.textContent)}catch{}
  for(const[key,url]of Object.entries(images))if(url){
   for(const img of document.querySelectorAll('[data-k]'))if(img.dataset.k===key)img.src=url;
  }
 }
})();
